import { ref, computed } from "vue";
import { searchDeceasedPerson, searchInheritance } from "../api";

export function useInheritanceVerification() {
  const checkResults = ref({
    existingCase: null,
    testament: null,
    territorial: null,
  });
  const isVerifying = ref(false);

  const isAccessGranted = computed(() => {
    const { territorial } = checkResults.value;
    // existingCase.found и testament.found НЕ блокируют — информационные
    if (territorial && !territorial.passed) return false;
    return true;
  });

  const hasChecked = computed(() => {
    return (
      checkResults.value.existingCase !== null ||
      checkResults.value.testament !== null
    );
  });

  async function runChecks(inheritanceId, params) {
    isVerifying.value = true;
    try {
      let caseRes, testRes;
      try {
        [caseRes, testRes] = await Promise.all([
          searchDeceasedPerson(inheritanceId, {
            iin: params.iin,
            first_name: params.first_name,
            last_name: params.last_name,
            middle_name: params.middle_name,
            birth_date: params.birth_date,
            death_date: params.death_date,
          }),
          searchInheritance(inheritanceId, {
            iin: params.iin,
            first_name: params.first_name,
            last_name: params.last_name,
            middle_name: params.middle_name,
            birth_date: params.birth_date,
            death_date: params.death_date,
          }),
        ]);
      } catch {
        caseRes = null;
        testRes = null;
      }

      checkResults.value.existingCase = {
        found: !!caseRes?.payload?.existing_nd_found,
        data: caseRes?.payload || null,
        message: caseRes?.payload?.result?.note_ru
          ? caseRes.payload.result?.note_ru
          : "Наследственных дел не обнаружено",
      };

      checkResults.value.testament = {
        found: !!testRes?.payload?.existing_nd_found,
        data: testRes?.payload || null,
        message:
          testRes?.payload?.message ||
          (testRes?.payload?.existing_nd_found
            ? "Найдено завещание"
            : "Завещания не найдено"),
      };

      // Территориальный округ — заглушка (бэк не готов)
      checkResults.value.territorial = { passed: true, message: "" };

      return checkResults.value;
    } finally {
      isVerifying.value = false;
    }
  }

  function reset() {
    checkResults.value = {
      existingCase: null,
      testament: null,
      territorial: null,
    };
    isVerifying.value = false;
  }

  return {
    checkResults,
    isVerifying,
    isAccessGranted,
    hasChecked,
    runChecks,
    reset,
  };
}
